import { FC } from "react";
import { Button, ButtonGroup, Grid, GridItem, Heading, useDisclosure, VStack, Text } from "@chakra-ui/react";
import { TeamUsageAlert } from "../team/teamUsageAlert";
import { SubscriptionDetails } from "./subscriptionDetails";
import { UpdateBillingDetails } from "./updateBillingDetails";
import { ReSubscribe } from "./resubscribe";
import { has } from "ramda";
import { useBilling, useLoggedinUser } from "lib/hooks";
import { useRouter } from "next/router";

const hasPaymentMethod = has('payment_method');

export const BillingOverview: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { data, isLoading: isLoadingBilling } = useBilling();
  const { isVerified, isLoading } = useLoggedinUser();
  const router = useRouter();

  if (isLoadingBilling || isLoading) {
    return null;
  }

  if (!isVerified) {
    return null;
  }

  if (!hasPaymentMethod(data) && !!data) {
    return (
      <VStack align="start" spacing={5} mt={5}>
        <Heading as="h5" size="md">Upgrade your account</Heading>
        <Text>We’re so glad you’re loving Packs! 😊 Upgrade to the next tier up for just $10/team member/month.</Text>
        <Text>(You won’t be charged until your team’s free trial runs out.)</Text>
        <Button
          variant={"primary"}
          onClick={() => router.push('/upgrade-account')}
        >
          Upgrade plan
        </Button>
      </VStack>
    )
  }

  return (
    <VStack align="stretch" spacing="15px">
      <Grid autoFlow="column" justifyContent="space-between">
        <GridItem>
          <Heading as="h5" size="md">Billing Details</Heading>
        </GridItem>
        <GridItem>
          <Button variant="link" onClick={() => onOpen()}>View app usage</Button>
          <TeamUsageAlert isOpen={isOpen} onClose={onClose} />
        </GridItem>
      </Grid>
      <SubscriptionDetails />
      <ButtonGroup spacing="20px" width="100%" justifyContent="flex-end">
        <UpdateBillingDetails />
        <ReSubscribe />
      </ButtonGroup>
    </VStack>
  )
}
